import { DataTransaction, KSstats, KSTransaction } from './types';

export function calculateStats(values: number[]): KSstats {
  const count = values.length;
  if (count === 0) {
    throw new Error('Cannot calculate stats for empty array');
  }

  const sorted = [...values].sort((a, b) => a - b);
  const sum = values.reduce((acc, val) => acc + val, 0);
  const mean = sum / count;
  const variance = values.reduce((acc, val) => acc + Math.pow(val - mean, 2), 0) / count;
  const stdDev = Math.sqrt(variance);

  const median = count % 2 === 0 ? (sorted[count / 2 - 1] + sorted[count / 2]) / 2 : sorted[Math.floor(count / 2)];

  // Calculate quartiles for IQR
  const q1Index = Math.floor(count * 0.25);
  const q3Index = Math.floor(count * 0.75);
  const q1 = sorted[q1Index];
  const q3 = sorted[q3Index];
  const iqr = q3 - q1;

  return {
    count,
    min: sorted[0],
    max: sorted[count - 1],
    stdDev,
    median,
    mean,
    variance,
    sum,
    boundaries: {
      threeStdDev: {
        lower: mean - 3 * stdDev,
        upper: mean + 3 * stdDev,
      },
      iqr: {
        q1,
        q3,
        lower: q1 - 1.5 * iqr,
        upper: q3 + 1.5 * iqr,
      },
    },
  };
}

export const convertDataTransactionToKSTransaction = (
  dataTransaction: DataTransaction,
  period: number = 0,
  accountId: string,
  id: number = 0
): KSTransaction => {
  const pastDue = dataTransaction.dueDate
    ? Math.max(
        0,
        Math.floor((new Date().getTime() - new Date(dataTransaction.dueDate).getTime()) / (1000 * 60 * 60 * 24))
      )
    : 0;
  return {
    id: id, // You might need to generate a unique ID. Probably a UUID or incrementing number
    amount: dataTransaction.amount,
    description: dataTransaction.description,
    category: dataTransaction.type,
    accountId: accountId, // To be filled in later
    name: dataTransaction.name,
    vendorId: 0, // To be filled in later
    period: period, // To be filled in later
    txnDate: dataTransaction.txnDate,
    date: new Date(dataTransaction.txnDate),
    dueDate: dataTransaction.dueDate || '',
    pastDue: pastDue,
    eventId: dataTransaction.eventId,
    num: dataTransaction.num,
    notes: '',
    audit: {
      status: 'Normal',
      amount: 0,
      reason: '',
    },
  };
};
